const { REACT_APP_SERVER_URL } = process.env;

const environment = {
  SERVER_URL: REACT_APP_SERVER_URL
};

export const parts = {
  SYSTEM_PROCESSES: "systemProcesses",

  CLASSIFICATION_TYPES: "classificationTypes",
  CLASSIFICATION_STATUSES: "classificationStatuses",
  CLASSIFICATIONS: "classifications",

  ENTITIES: "entities",
  KNOWLEDGES: "knowledges",
  KNOWLEDGE_TYPES: "knowledgeTypes",
  KNOWLEDGE_COPYRIGHTS: "knowledgeCopyrights",
  KNOWLEDGE_SOURCES: "knowledgeSources",
  KNOWLEDGE_SOURCE_CLASSIFICATIONS: "knowledgeSourceClassifications",
  LIFE_CYCLES: "lifeCycles",
  DOCUMENTS: "documents",
  ENTITY_RATINGS: "entityRatings",
  ENTITY_MESSAGE_LOGS: "generalEntityMessageLogs",
  ENTITY_MESSAGE_LOG_TYPES: "generalEntityMessageLogTypes",
  LIFE_CYCLE_STATE_TYPES: "lifeCycleStateTypes",
  LIFE_CYCLE_CLASS_DEFINITIONS: "lifeCycleClassDefinitions",
  LIFE_CYCLE_HISTORY_LOGS: "lifeCycleHistoryLogs",
  INVOLVEMENT_ROLES: "involvementRoles",
  INVOLVEMENT_ROLE_TYPES: "involvementRoleTypes",
  PARTY_ROLES: "partyRoles",
  PARTY_ROLES_TYPES: "partyRoleTypes",
  PARTY_ROLE_TYPE_DISCRIMINATORS: "partyRoleTypeDiscriminators",
  EXTENSIONS: "extensions",
  LANGUAGES: "languages",
  PARTIES: "parties",
  INDIVIDUALS: "individuals",
  OPERATIONS: "operations",
  TAGS: "tags",
  GET_OCCURRENCE: "occurrences",
  ELASTIC_SEARCH: "elasticsearch",
  REINDEX: "reindex",
  STATUS: "status",
  PARTY_SUBSCRIPTIONS: "partySubscriptions",
  PARTY_MESSAGES: "partyMessages",
  READ: "read",
  ENTITY_RELATIONSHIPS: "entityRelationships",
  ENTITY_RELATIONSHIP_TYPES: "entityRelationshipTypes",
  RELATION_CARDINALITY_TYPES: "relationCardinalityTypes",
  WEBSOCKETS: "websockets",
  COMPACT_VIEW: "compact-view",
  SEARCH_SIMILAR: "searchSimilar",
  SEARCH: "search",
  OCCURRENCES: "occurrences",
  CURRENT: "current",
  RECOMMENDED: "recommended",
  ORGANISATIONS: "organisations"
};

export const URL_SEPARATOR = "/";

export const urls = {
  CURRENT_PARTY_URL:
    environment.SERVER_URL +
    URL_SEPARATOR +
    parts.PARTIES +
    URL_SEPARATOR +
    parts.CURRENT,
  SYSTEM_PROCESSES_URL: URL_SEPARATOR + parts.SYSTEM_PROCESSES,

  CLASSIFICATION_TYPES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.CLASSIFICATION_TYPES,
  CLASSIFICATION_STATUSES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.CLASSIFICATION_STATUSES,
  CLASSIFICATIONS_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.CLASSIFICATIONS,

  ENTITIES_URL: environment.SERVER_URL + URL_SEPARATOR + parts.ENTITIES,
  KNOWLEDGES_URL: environment.SERVER_URL + URL_SEPARATOR + parts.KNOWLEDGES,
  KNOWLEDGE_TYPES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.KNOWLEDGE_TYPES,
  KNOWLEDGE_COPYRIGHTS_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.KNOWLEDGE_COPYRIGHTS,
  KNOWLEDGE_SOURCES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.KNOWLEDGE_SOURCES,
  KNOWLEDGE_SOURCE_CLASSIFICATIONS_URL:
    environment.SERVER_URL +
    URL_SEPARATOR +
    parts.KNOWLEDGE_SOURCE_CLASSIFICATIONS,
  LIFE_CYCLES_URL: environment.SERVER_URL + URL_SEPARATOR + parts.LIFE_CYCLES,
  DOCUMENTS_URL: environment.SERVER_URL + URL_SEPARATOR + parts.DOCUMENTS,
  ENTITY_RATINGS_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.ENTITY_RATINGS,
  ENTITY_MESSAGE_LOGS_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.ENTITY_MESSAGE_LOGS,
  ENTITY_MESSAGE_LOG_TYPES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.ENTITY_MESSAGE_LOG_TYPES,
  LIFE_CYCLE_STATE_TYPES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.LIFE_CYCLE_STATE_TYPES,
  LIFE_CYCLE_CLASS_DEFINITIONS_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.LIFE_CYCLE_CLASS_DEFINITIONS,
  LIFE_CYCLE_HISTORY_LOGS_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.LIFE_CYCLE_HISTORY_LOGS,
  INVOLVEMENT_ROLES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.INVOLVEMENT_ROLES,
  INVOLVEMENT_ROLE_TYPES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.INVOLVEMENT_ROLE_TYPES,
  PARTY_ROLES_URL: environment.SERVER_URL + URL_SEPARATOR + parts.PARTY_ROLES,
  PARTY_ROLES_TYPES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.PARTY_ROLES_TYPES,
  PARTY_ROLE_TYPE_DISCRIMINATORS_URL:
    environment.SERVER_URL +
    URL_SEPARATOR +
    parts.PARTY_ROLE_TYPE_DISCRIMINATORS,
  EXTENSIONS_URL: environment.SERVER_URL + URL_SEPARATOR + parts.EXTENSIONS,
  LANGUAGES_URL: environment.SERVER_URL + URL_SEPARATOR + parts.LANGUAGES,
  PARTIES_URL: environment.SERVER_URL + URL_SEPARATOR + parts.PARTIES,
  INDIVIDUALS_URL: environment.SERVER_URL + URL_SEPARATOR + parts.INDIVIDUALS,
  PARTY_CLASSIFICATIONS_BY_OPERATION_URL:
    environment.SERVER_URL +
    URL_SEPARATOR +
    parts.PARTIES +
    URL_SEPARATOR +
    parts.CLASSIFICATIONS,
  OPERATIONS_URL: environment.SERVER_URL + URL_SEPARATOR + parts.OPERATIONS,
  TAGS_URL: environment.SERVER_URL + URL_SEPARATOR + parts.TAGS,
  ELASTIC_SEARCH_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.ELASTIC_SEARCH,
  ELASTIC_SEARCH_REINDEX_URL:
    environment.SERVER_URL +
    URL_SEPARATOR +
    parts.ELASTIC_SEARCH +
    URL_SEPARATOR +
    parts.REINDEX,
  PARTY_SUBSCRIPTIONS_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.PARTY_SUBSCRIPTIONS,
  PARTY_MESSAGES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.PARTY_MESSAGES,
  ENTITY_RELATIONSHIPS_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.ENTITY_RELATIONSHIPS,
  ENTITY_RELATIONSHIP_TYPES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.ENTITY_RELATIONSHIP_TYPES,
  RELATION_CARDINALITY_TYPES_URL:
    environment.SERVER_URL + URL_SEPARATOR + parts.RELATION_CARDINALITY_TYPES,
  WEBSOCKET_URL: environment.SERVER_URL + URL_SEPARATOR + parts.WEBSOCKETS,
  ORGANISATIONS_URL: environment.SERVER_URL + URL_SEPARATOR + parts.ORGANISATIONS
};
